export default "__VITE_ASSET__Bc8Ija99__"